module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notEnoughSpiff && _vm.accountAgents.length),
      expression: "notEnoughSpiff && accountAgents.length"
    }],
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v("  \n    "), _c('strong', [_vm._v("Commission & Spiff Rate must equal 100!")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row table-head"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._v("Agent Name")]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_vm._v("Commission Rate")]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_vm._v("Spiff Rate")]), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "col-3"
  }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.accountAgents), function(v, i) {
    return _c('div', {
      key: v.user_id,
      staticClass: "row lined"
    }, [_c('div', {
      staticClass: "col-4",
      on: {
        "click": function($event) {
          _vm.setSelected(v);
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.selected || _vm.selected.accountUser_id != v.accountUser_id),
        expression: "!selected || selected.accountUser_id != v.accountUser_id"
      }]
    }, [_vm._v(" " + _vm._s(v.user_name) + " ")]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('autocomplete', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!v.accountUser_id || (_vm.selected.accountUser_id != null && _vm.selected.accountUser_id == v.accountUser_id)),
        expression: "!v.accountUser_id || (selected.accountUser_id != null &&  selected.accountUser_id == v.accountUser_id)"
      }],
      attrs: {
        "selection": _vm.selected.user_name,
        "list": _vm.agentNames,
        "add": "",
        "addText": "Create New Agent",
        "placeholder": "Search For An Agent"
      },
      on: {
        "addClick": function($event) {
          _vm.showAddAgent = true;
        },
        "change": _vm.setAgent
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col text-right",
      on: {
        "click": function($event) {
          _vm.setSelected(v)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!_vm.selected || _vm.selected.accountUser_id != v.accountUser_id) && v.accountUser_id),
        expression: "(!selected || selected.accountUser_id != v.accountUser_id ) && v.accountUser_id"
      }]
    }, [_vm._v("\n        " + _vm._s(v.commsrate) + "%\n      ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!v.accountUser_id || (_vm.selected && _vm.selected.accountUser_id == v.accountUser_id)),
        expression: "!v.accountUser_id || ( selected && selected.accountUser_id == v.accountUser_id)"
      }, {
        name: "model",
        rawName: "v-model.lazy",
        value: (_vm.selected.commsrate),
        expression: "selected.commsrate",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(_vm.selected.commsrate)
      },
      on: {
        "change": function($event) {
          _vm.selected.commsrate = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col text-right",
      on: {
        "click": function($event) {
          _vm.setSelected(v)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!_vm.selected || _vm.selected.accountUser_id != v.accountUser_id) && v.accountUser_id),
        expression: "(!selected || selected.accountUser_id != v.accountUser_id ) && v.accountUser_id"
      }]
    }, [_vm._v("\n        " + _vm._s(v.spiffrate) + "%\n      ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!v.accountUser_id || (_vm.selected && _vm.selected.accountUser_id == v.accountUser_id)),
        expression: "!v.accountUser_id || ( selected && selected.accountUser_id == v.accountUser_id)"
      }, {
        name: "model",
        rawName: "v-model.lazy",
        value: (_vm.selected.spiffrate),
        expression: "selected.spiffrate",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(_vm.selected.spiffrate)
      },
      on: {
        "change": function($event) {
          _vm.selected.spiffrate = $event.target.value
        }
      }
    })]), _vm._v(" "), (!_vm.readonly) ? _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!_vm.selected || _vm.selected.accountUser_id != v.accountUser_id) && v.accountUser_id),
        expression: "(!selected || selected.accountUser_id != v.accountUser_id ) && v.accountUser_id"
      }],
      staticClass: "text-right"
    }, [(_vm.$store.getters.getUserRoles[8].rolesPermissions[11].state) ? _c('button', {
      staticClass: "btn btn-sm btn-light",
      on: {
        "click": function($event) {
          _vm.buyAgent = v
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dollar"
    })]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getUserRoles[8].rolesPermissions[11].state) ? _c('router-link', {
      staticClass: "btn btn-sm btn-light",
      attrs: {
        "to": '/agents/' + v.user_id
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    })]) : _vm._e(), _vm._v(" "), (v.editable) ? _c('dropdown-confirmation', {
      on: {
        "confirm": function($event) {
          _vm.deleteAgent(v)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!v.accountUser_id || (_vm.selected && _vm.selected.accountUser_id == v.accountUser_id)),
        expression: "!v.accountUser_id || ( selected && selected.accountUser_id == v.accountUser_id)"
      }],
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-light",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setAgentDetails(_vm.selected)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-list"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-success",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.updateAgent(_vm.selected)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.cancel(_vm.selected)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })])])]) : _vm._e()])
  }), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addAgent($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  Add Agent")])])]) : _vm._e(), _vm._v(" "), (_vm.buyAgent) ? _c('modal', {
    attrs: {
      "allow-click-away": "false"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h3', {
    staticClass: "modal-title d-inline d-flex justify-content-start"
  }, [_vm._v("Buy Commissions")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.buyAgent = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]), _vm._v(" "), _c('buy-commissions', {
    attrs: {
      "userName": _vm.getAgentName(_vm.buyAgent),
      "agent": _vm.buyAgent
    },
    on: {
      "close": function($event) {
        _vm.buyAgent = null
      },
      "refetch": function($event) {
        _vm.$emit('fetchAccountAgents')
      }
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showBuyCommissions) ? _c('modal', {
    attrs: {
      "allow-click-away": "false"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h3', {
    staticClass: "modal-title d-inline d-flex justify-content-start"
  }, [_vm._v("Buy Commissions")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.buyAgent = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]), _vm._v(" "), _c('buy-commissions', {
    attrs: {
      "userName": _vm.getAgentName(_vm.buyAgent),
      "agent": _vm.buyAgent
    },
    on: {
      "close": function($event) {
        _vm.buyAgent = null
      },
      "refetch": function($event) {
        _vm.$emit('fetchAccountAgents')
      }
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAgentDetails) ? _c('modal', {
    attrs: {
      "size": "lg"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h3', {
    staticClass: "modal-title d-inline d-flex justify-content-start"
  }, [_vm._v("Agent Commission Rates")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAgentDetails = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Tier 1 Comms\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedAgentCommissionDetails.tier1_commsrate) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Tier 1 Spiff\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedAgentCommissionDetails.tier1_spiffrate) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setCommRate(_vm.selectedAgentCommissionDetails.tier1_commsrate, _vm.selectedAgentCommissionDetails.tier1_spiffrate)
      }
    }
  }, [_vm._v("Use This Rate")])])]), _vm._v(" "), _c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Tier 2 Comms\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedAgentCommissionDetails.tier2_commsrate) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Tier 2 Spiff\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedAgentCommissionDetails.tier2_spiffrate) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setCommRate(_vm.selectedAgentCommissionDetails.tier2_commsrate, _vm.selectedAgentCommissionDetails.tier2_spiffrate)
      }
    }
  }, [_vm._v("Use This Rate")])])]), _vm._v(" "), _c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Tier 3 Comms\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedAgentCommissionDetails.tier3_commsrate) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Tier 3 Spiff\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedAgentCommissionDetails.tier3_spiffrate) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setCommRate(_vm.selectedAgentCommissionDetails.tier3_commsrate, _vm.selectedAgentCommissionDetails.tier3_spiffrate)
      }
    }
  }, [_vm._v("Use This Rate")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Tier 4 Comms\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedAgentCommissionDetails.tier4_commsrate) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Tier 4 Spiff\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedAgentCommissionDetails.tier4_spiffrate) + "%\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setCommRate(_vm.selectedAgentCommissionDetails.tier4_commsrate, _vm.selectedAgentCommissionDetails.tier4_spiffrate)
      }
    }
  }, [_vm._v("Use This Rate")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showAddAgent) ? _c('modal', {
    attrs: {
      "size": "lg"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h3', {
    staticClass: "modal-title d-inline d-flex justify-content-start"
  }, [_vm._v("Add Agent")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddAgent = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]), _vm._v(" "), _c('add-agent', {
    attrs: {
      "stay": ""
    },
    on: {
      "close": function($event) {
        _vm.showAddAgent = false
      },
      "saved": _vm.setNewAgent
    },
    slot: "body"
  })], 1) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row heading"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Agents")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4696e8a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/AccountAgents.vue
// module id = 386
// module chunks = 0